/**
 * Resolves once the given IndexedDB transaction commits.
 *
 * A transaction settles on `oncomplete`, never on a request's `onsuccess`: only the transaction
 * knows every request inside it has committed.
 *
 * Rejects with the transaction's own `error`, or with one of the two fallback messages when the
 * browser gives none — `fallbackErrorMessage` on `onerror`, `fallbackAbortMessage` on `onabort` —
 * so the caller keeps control of which subsystem the rejection names.
 */
const waitForIndexedDbTransaction = (
	transaction: IDBTransaction,
	fallbackErrorMessage: string,
	fallbackAbortMessage: string,
): Promise<void> => {
	return new Promise((resolve, reject) => {
		transaction.oncomplete = () => {
			resolve();
		};
		transaction.onerror = () => {
			reject(transaction.error ?? new Error(fallbackErrorMessage));
		};
		transaction.onabort = () => {
			reject(transaction.error ?? new Error(fallbackAbortMessage));
		};
	});
};

export default waitForIndexedDbTransaction;
